import chatMessages from './middleware/chatMessages'
import config from './config'
import dashboardMiddleware from './middleware/dashboard'
import jsonMessages from './middleware/jsonMessages'
import lspAgentRouteMiddleware from './middleware/routing'
import sessionControlMiddle from './middleware/sessionControl'
import rootReducer from './rootReducer'
import thunk from 'redux-thunk'
import {createMiddleware as kandyCreateMiddleware} from 'kandy-redux'
import {createStore, compose, applyMiddleware, bindActionCreators} from 'redux'
import {createLogger} from 'redux-logger';
import sessionTimer from './middleware/sessionTimer'
import customer from './middleware/customer'
import reportPreview from './lossAss/middleware/reportPreview'
import currentAgent from './middleware/currentAgent'
import wxSmProgram from './lossAss/middleware/wxSmProgram'
import { callActions, reportDetailActions } from './actions';

let store

let configureStore = (initialState = {}) => {

    const kandyMiddleware = kandyCreateMiddleware(config.kandyApiKey, config.chromeExtensionId)
    const logger = createLogger();
    store = compose(
        applyMiddleware(
			thunk,
            lspAgentRouteMiddleware,
            dashboardMiddleware,
            kandyMiddleware,
            jsonMessages,
            sessionTimer,
            chatMessages,
            sessionControlMiddle,
            customer,
            reportPreview,
            currentAgent,
            // wxSmProgram,
            // logger,//logger必须放在中间件函数最后！！！否则获取log可能有误
        ),
        // reduxReactRouter({
        //     routes,
        //     createHistory
        // }),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )(createStore)(rootReducer, initialState)
    //console.log(JSON.stringify(initialState,null,4))

    return store
}
let getStore = () => {
    return store
}
// 获取store中的数据
let getState = () => {
    return getStore().getState()
}

let initStore = configureStore({
    userInfo: {
		tenant: {}
	}
})
let boundActions = bindActionCreators({...callActions, ...reportDetailActions}, initStore.dispatch);

export {configureStore, getStore, getState, initStore, boundActions }
